<template>
    <li class="list pa3 hover-bg-light-gray black pointer" @click="onClick()">
        <h6>
            <slot></slot>
        </h6>
    </li>
</template>

<script>
export default {
    props: {
        link: {
            type: String
        }
    },
    methods: {
        onClick() {
            if (this.link) {
                this.$router.push(this.link);
            } else {
                this.$emit('click');
            }
        }
    }
};
</script>
